import React from 'react';
import Grid from '@clasohlson/co-ui-components/Grid';
import Column from '@clasohlson/co-ui-components/Column';
import Box from '@clasohlson/co-ui-components/Box';
// import { useTranslation } from 'react-i18next';
import { FindStores } from '../components/findStores/FindStores';
import { ContactBox } from '../components/contactBox/ContactBox';
import { OrderSearch } from '../components/orderSearch/OrderSearch';
import { ProcessDescription } from '../components/orderSearch/ProcessDescription';
import styled from 'styled-components';
import { ExpandBox } from '../components/expandBox/ExpandBox';
import { HandBagIcon, BoxClosedIcon, BoxHelpIcon, ScreenBoxIcon } from '../components/icons';
import customTheme from '../theme';
import { CustomButton } from '../components/button/CustomButton';
import { useTranslation } from '../utils';

// const boxIcon = require('../assets/box-black-closed.svg');
// const calClockIcon = require('../assets/calendar-clock-blue.svg');

const BorderedBox = styled.div`
  background: transparent;
  margin-bottom: 8px;
  h4,
  .h4 {
    font-weight: 600;
  }
  @media screen and (min-width: 640px) {
    background: #f7f7f7;
    // border: 1px solid #e2e2e2;
    margin-bottom: 26px;
  }
`;

const StyledDivider = styled.div`
  position: absolute;
  width: 1px;
  height: 73%;
  left: 50%;
  top: 50%;
  transform: translateY(-50%);
  background: ${({ theme }) => theme.colors.mediumGray};
  display: none;
  padding: 0 !important;
  margin-left: 0.625rem;
  margin-top: 0.625rem;
  @media screen and (min-width: 640px) {
    display: block;
  }
`;

const DashedDivider = styled.div`
  height: 1px;
  margin: 0;
  background-image: linear-gradient(90deg, #d1d1d1, #d1d1d1 50%, transparent 50%, transparent 100%);
  background-size: 12px 1px;
  margin: 28px 0 26px 0;
  @media screen and (min-width: 640px) {
    display: block;
    margin: 51px 0 41px 0;
  }
`;

const MainTitle = styled.h2`
  font-family: 'Clas Ohlson Sans Web', 'Open Sans', 'Arial' !important;
  font-size: 28px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.39;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
  margin-bottom: 10px;
  margin-top: 0;
  @media screen and (max-width: 600px) {
    font-size: 18px;
  }
`;

const MainText = styled.p`
  font-family: 'Clas Ohlson Sans Web', 'Open Sans', 'Arial' !important;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  margin-top: 0;
  margin-bottom: 41px;
  @media screen and (max-width: 600px) {
    margin-bottom: 22px;
    font-size: 13px;
  }
`;

const BoxDescription = styled.p`
  margin: 0;
  font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  /* text-align: center; */
`;

const CustomGrid = styled(Grid)`
  @media screen and (max-width: 600px) {
    flex-direction: column;
    > div {
      padding-top: 0.5rem;
    }
  }
`;

export const Home = () => {
  const { t } = useTranslation();

  // const lang = i18n.language;
  // const country = getCountryCodeFromUrl();

  if (document.querySelectorAll('.account__section__details').length) {
    return null;
  }
  return (
    <React.Fragment>
      <BoxClosedIcon
        fontSize="66"
        color={customTheme.colors.text}
        style={{ margin: '0 auto 13px auto' }}
      />
      {/* <img src={boxIcon} /> */}
      <MainTitle>{t('returnProduct')}</MainTitle>
      <MainText>{t('introduction')}</MainText>
      <BorderedBox>
        <CustomGrid spacing="large" style={{ position: 'relative' }}>
          <Column lg="6" md="6" sm="6" xs="12">
            <ExpandBox image={<HandBagIcon fontSize="48" />} title={t('searchStoreTitle')}>
              <p>{t('searchStoreDescription')}</p>
              <FindStores />
            </ExpandBox>
          </Column>
          <Column lg="6" md="6" sm="6" xs="12">
            <ExpandBox
              defaultOpen
              image={<ScreenBoxIcon fontSize="48" />}
              title={t('searchOrderTitle')}
            >
              <p>{t('searchOrderDescription')}</p>
              <OrderSearch />
            </ExpandBox>
          </Column>
          <StyledDivider />
        </CustomGrid>
      </BorderedBox>
      <Grid spacing="none">
        <Column lg="4" md="4" sm="6" xs="12" lgOffset="8" mdOffset="8" smOffset="3">
          <CustomButton
            className="js-open-login-flyout"
            bgColor="#eeeeec"
            fullWidth
            priority="secondary"
          >
            {t('loginBtnText')}
          </CustomButton>
          <Box topSpacing="medium">
            <BoxDescription>
              {t('privacyStatementText')}
              <br />
              <a href={t('privacyStatementLink')} rel="noreferrer">
                {t('privacyStatementLinkLabel')}
              </a>
            </BoxDescription>
          </Box>
        </Column>
      </Grid>
      <DashedDivider />
      <BoxHelpIcon
        fontSize="66"
        color={customTheme.colors.text}
        style={{ margin: '0 auto 13px auto' }}
      />
      <MainTitle>{t('termsTitle')}</MainTitle>
      <MainText>{t('termsDescription')}</MainText>
      <ProcessDescription />
      <ContactBox />
    </React.Fragment>
  );
};
